<template>
  <label class="d-block mb-1 gray--text" v-bind="$attrs">
    <slot/>
  </label>
</template>

<script>
export default {}
</script>